import GlobalResponseStatusStore from '../../lib/stores/ResponseStatusStore'

class ResponseStatusStore extends GlobalResponseStatusStore {}

const responseStatusStore = new ResponseStatusStore()

export { responseStatusStore }
